
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoadingProvider, useLoading } from './components/common/LoadingContext';
import { configureAxios } from './apis/index';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Home from './components/pages/HomePage';
import Offers from './components/pages/OfferPage';
import Giveaway from './components/pages/GiveawayPage';
import GiveawayDetailsPage from './components/pages/GiveawayDetailsPage';
import Events from './components/pages/EventsPage';
import Plans from './components/pages/PlansPage';
import Partners from './components/pages/PartnersPage';
import Login from './components/pages/LoginPage';
import Signup from './components/pages/SignupPage';
import Renew from './components/pages/RenewPage';
import Forgotpassword from './components/pages/ForgotPassword';
import ResetPassword from './components/pages/ResetPassword';
import SendOtp from './components/pages/SendOtp';
import Dashboard from './components/pages/Dashboard';
import DashboardOffers from './components/pages/Dashboard/Offers';
import DashboardGiveaways from './components/pages/Dashboard/GiveAways';
import DashboardEvents from './components/pages/Dashboard/Events';
import DashboardCoupons from './components/pages/Dashboard/Coupons';
import EventDetails from './components/pages/Dashboard/Events/EventDetails';
import OfferDetails from './components/pages/Dashboard/OfferDetails';
import OfferDetailsStatic from './components/common/OfferDetailsStatic';
import GiveAwayDetails from './components/pages/Dashboard/GiveAways/GiveAwayDetails';
import GiveawayDetailsStatic from './components/common/GiveawayDetailsStatic';
import EventDetailsStatic from './components/common/EventDetailsStatic';
import LiveTestStatic from './components/common/LiveTestStatic';
import CheckMyTicket from './components/pages/Dashboard/CheckMyTicket';
import MySubscription from 'components/pages/Dashboard/MySubscription';
import MyAccount from 'components/pages/Dashboard/MyAccount';
import PartnerLoginPage from './components/pages/Partner/PartnerLoginPage';
import PartnerVerifyPage from './components/pages/Partner/PartnerVerifyPage';
import ScrollToTop from './components/common/ScrollToTop';
import { DeviceProvider } from './DeviceContext';
import Ride24App from './ride-24/Ride24App';


function AppContent() {
  const { loading, setLoading } = useLoading();

  useEffect(() => {
    configureAxios(setLoading);
  }, [setLoading]);

  function CircularColor() {
    return (
      <div style={{
        position: 'fixed',  // Full-screen overlay
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',  // Semi-transparent background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,  // Ensure it's above other content
      }}
      >
        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
          <CircularProgress color="secondary" />
          <CircularProgress color="success" />
          <CircularProgress color="inherit" />
        </Stack>
      </div>
    );
  }

  return (
    <div className="App">
      {loading && <CircularColor />}
      <DeviceProvider>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/Offers' element={<Offers />} />
        <Route path='/Giveaway' element={<Giveaway />} />
        <Route path='/Giveaway/:id' element={<GiveawayDetailsPage />} />
        <Route path='/Events' element={<Events />} />
        <Route path='/Plans' element={<Plans />} />
        <Route path='/Partners' element={<Partners />} />
        <Route path='/Login' element={<Login />} />
        <Route path='/Signup' element={<Signup />} />
        <Route path='/renew' element={<Renew />} />
        <Route path='/Forgotpassword' element={<Forgotpassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/Sendotp' element={<SendOtp />} />
        <Route path='/partner/verify/login' element={<PartnerLoginPage />} />
        <Route path='/partner/verify' element={<PartnerVerifyPage />} />
        {/* Design/proportion test page for the benefits tile - not linked from the UI */}
        <Route path='/live-test' element={<LiveTestStatic />} />
        <Route path='/ride-24/*' element={<Ride24App />} />
        <Route path='/dashboard' element={<Dashboard />}>
          <Route index element={<DashboardOffers />} />
          <Route path="giveaways" element={<DashboardGiveaways />} />
          <Route path="giveaway/:id" element={<GiveawayDetailsStatic />} />
          {/* Old dashboard giveaway details - kept for reference/backup only, not linked from the UI anymore */}
          <Route path="giveaway-legacy/:id" element={<GiveAwayDetails />} />
          <Route path="events" element={<DashboardEvents />} />
          <Route path="events/:id" element={<EventDetailsStatic />} />
          {/* Old dashboard event details - kept for reference/backup only, not linked from the UI anymore */}
          <Route path="events-legacy/:id" element={<EventDetails />} />
          <Route path="coupons" element={<DashboardCoupons />} />
          <Route path="offers/:id" element={<OfferDetailsStatic />} />
          {/* Old dashboard offer details - kept for reference/backup only, not linked from the UI anymore */}
          <Route path="offers-legacy/:id" element={<OfferDetails />} />
          <Route path="check-ticket" element={<CheckMyTicket />} />
          <Route path="my-subscription" element={<MySubscription />} />
          <Route path="my-account" element={<MyAccount />} />
        </Route>
      </Routes>
      </DeviceProvider>
    </div>
  );
}

function App() {
  return (
    <LoadingProvider>
      
        <AppContent />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      
    </LoadingProvider>
  );
}

export default App;
